<script>
  import { onMount } from "svelte";
  import { Modal } from "svelte-utilities";
  import { profile } from "#src/stores/auth.js";
  import { ws, api } from "#src/api";

  import GuardedTextInput from "#lib/sidebar/GuardedTextInput.svelte";

  let clientReloadModal;

  let singleOpeningPrompt = "";
  let multipleOpeningsPrompt = "";

  async function updatePrompt(type, value) {
    await api.from("llm_prompts").update({ prompt: value }).eq("name", type);
  }

  async function resetPrompt(type) {
    const prompt = await api.from("llm_prompts").select("*").eq("name", `${type}_default`).single();
    if (prompt.error) {
      console.log("Error fetching default prompt:", prompt.error);
    } else {
      const defaultPrompt = prompt.data.prompt;
      await api.from("llm_prompts").update({ prompt: defaultPrompt }).eq("name", type);

      if (type === "single_opening") {
        singleOpeningPrompt = defaultPrompt;
      } else if (type === "multiple_openings") {
        multipleOpeningsPrompt = defaultPrompt;
      }
    }
  }

  async function reloadClients() {
    const { data } = await api.auth.getSession();
    const { access_token } = data.session;
    ws.send(JSON.stringify({ action: "update-appid", token: access_token }));
  }

  onMount(async () => {
    const prompts = await api.from("llm_prompts").select("*").order("created_at", { ascending: true });
    if (prompts.error) {
      console.log("Error fetching prompts:", prompts.error);
    } else {
      singleOpeningPrompt = prompts.data.find((p) => p.name === "single_opening")?.prompt || "";
      multipleOpeningsPrompt = prompts.data.find((p) => p.name === "multiple_openings")?.prompt || "";
    }
  });
</script>

<div class="px-4 pb-4 border-b border-gray-300">
  <h2>Developer</h2>
</div>

{#if $profile?.user_role === "developer"}
  <div class="py-4 space-y-4">
    <!-- <div class="w-full space-y-4 sm:w-96">
      <div class="flex items-center gap-2">
        <GuardedTextInput
          label="AI Prompt: Single Opening"
          labelWidth="12rem"
          border
          contenteditable
          warningText={""}
          value={singleOpeningPrompt}
          on:input={(e) => updatePrompt("single_opening", e.detail.value)} />
        <button class="flex-none btn" on:click={() => resetPrompt("single_opening")}>Reset to Default</button>
      </div>
      <div class="flex items-center gap-2">
        <GuardedTextInput
          label="AI Prompt: Multiple Openings"
          labelWidth="12rem"
          border
          contenteditable
          warningText={""}
          value={multipleOpeningsPrompt}
          on:input={(e) => updatePrompt("multiple_openings", e.detail.value)} />
        <button class="flex-none btn" on:click={() => resetPrompt("multiple_openings")}
          >Reset to Default</button>
      </div>
    </div> -->
    <div class="py-4 sm:px-4 text-sm flex">
      <div class="w-full sm:w-96 space-y-4">
        <button class="my-4 px-4 btn btn-danger w-full" on:click={() => clientReloadModal.open()}>
          Force Client Reload
        </button>
      </div>
    </div>
  </div>
{/if}

<Modal
  bind:this={clientReloadModal}
  on:confirm={reloadClients}
  buttons={[
    { label: "Cancel", type: "cancel" },
    { label: "Force Reload", type: "confirm", style: "danger" },
  ]}
  closeOnOutclick>
  <div slot="title">Reload Clients</div>
  <div slot="content">Are you sure you want to force all clients to reload?</div>
</Modal>
